enum FileTypes {
    XlsOperatorIdeaTool = "OperatorIdeaTool",
    XlsConsumerIdeaTool = "ConsumerIdeaTool",
    Pdf = "Pdf",
    Ppt = "Ppt",
    SamplePdf = "SamplePdf",
    None = "None"
}

export default FileTypes;